module.exports = __webpack_public_path__ + "canju.png?e72a0c63bac59fc13d7936d743aa2e28";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/canju.png
// module id = 10
// module chunks = 0